var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeVisit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0 { fill: #FFFFFF; } /* Changed fill to white */\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.39,123.391l-59.236,59.228l-59.22-59.228c-17.226,8.113-31.83,26.963-31.83,44.673v162.064       c0,11.679,9.474,21.152,21.144,21.152c5.754,0,0,0,14.768,0l8.048,138.216c0,12.432,10.08,22.504,22.504,22.504       c5.245,0,14.915,0,24.586,0c9.687,0,19.357,0,24.602,0c12.424,0,22.505-10.072,22.505-22.504l8.048-138.216       c14.752,0,9.015,0,14.752,0c11.686,0,21.144-9.474,21.144-21.152V168.064C361.221,150.354,346.617,131.504,329.39,123.391z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.661,96.435c26.636,0,48.206-21.594,48.206-48.205c0-26.652-21.57-48.23-48.206-48.23       c-26.651,0-48.222,21.578-48.222,48.23C222.44,74.841,244.011,96.435,270.661,96.435z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.167,362.581h-35.945c-3.558,0-6.426,2.868-6.426,6.425v104.639c0,3.556,2.868,6.425,6.426,6.425h35.945       c3.54,0,6.425-2.868,6.425-6.425V369.006C199.591,365.45,196.706,362.581,193.167,362.581z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "257.189,116.76 257.189,154.64 270.154,171.989 283.135,154.64 283.135,116.76 270.154,116.76  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeVisit);
export default __webpack_public_path__ + "static/media/office-visit.a1f46d84ac24bf60cd77949f8e747a69.svg";
export { ForwardRef as ReactComponent };